// src/pages/Profile.js
import { useAuth } from '../hooks/useAuth';
import { User, Mail, LogOut } from 'lucide-react';

const Profile = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="relative overflow-hidden py-12">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-blue-900/20" />
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left px-4 py-8 mb-12">
            <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent mb-4">
              Hello{user?.displayName ? `, ${user.displayName.split(' ')[0]}` : ''}!
            </h1>
            <p className="text-purple-400 text-lg">Your account</p>
          </div>

          {/* Profile Card */}
          <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-xl p-8 shadow-2xl">
            <div className="flex items-center gap-4 mb-8">
              {user?.photoURL ? (
                <img
                  src={user.photoURL}
                  alt={user.displayName || 'Profile'}
                  className="w-16 h-16 rounded-full border-2 border-purple-500/50"
                />
              ) : (
                <div className="w-16 h-16 rounded-full bg-slate-700 flex items-center justify-center border-2 border-purple-500/50">
                  <User className="w-8 h-8 text-purple-400" />
                </div>
              )}
              <div>
                <p className="text-xl font-semibold text-white">
                  {user?.displayName || 'Google User'}
                </p>
                <p className="text-sm text-gray-400">Signed in with Google</p>
              </div>
            </div>

            <div className="space-y-4 mb-8">
              <div>
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1.5">
                  Email Address
                </label>
                <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-slate-800/50 border border-slate-700">
                  <Mail className="w-4 h-4 text-gray-500 shrink-0" />
                  <span className="text-gray-300 text-sm">{user?.email}</span>
                </div>
              </div>

              {user?.displayName && (
                <div>
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1.5">
                    Display Name
                  </label>
                  <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-slate-800/50 border border-slate-700">
                    <User className="w-4 h-4 text-gray-500 shrink-0" />
                    <span className="text-gray-300 text-sm">{user.displayName}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 mb-8">
              <p className="text-blue-400 text-sm">
                You're signed in with Google. Account details are managed through your Google account.
              </p>
            </div>

            <button
              onClick={logout}
              className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-gray-300 hover:text-white text-sm font-medium transition-colors border border-slate-700"
            >
              <LogOut className="w-4 h-4" />
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
